import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import LaunchpadGrid from "./LaunchpadGrid";
import LaunchpadDetails from "./LaunchpadDetails";

const LaunchpadPage = () => {
  const [selectedLaunchpad, setSelectedLaunchpad] = useState(null);
  const navigate = useNavigate();

  const handleLaunchpadClick = (launchpad) => {
    setSelectedLaunchpad(launchpad);
  };

  const handleBack = () => {
    setSelectedLaunchpad(null);
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] text-body flex flex-col items-center p-4">
      {/* Branded Header */}
      <div className="w-full bg-white/80 backdrop-blur-md border-b border-purple-100 py-4 px-8 mb-8 flex justify-between items-center rounded-2xl shadow-sm">
        <div className="flex items-center gap-4">
          <button
            onClick={() => navigate('/dashboard')}
            className="p-2 hover:bg-purple-50 rounded-lg text-[#5B21B6] transition-colors"
          >
            <FaArrowLeft />
          </button>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#5B21B6] rounded-xl flex items-center justify-center text-white font-black shadow-lg shadow-purple-200">
              SG
            </div>
            <h1 className="text-xl font-black text-gray-900 tracking-tight">
              TheSkillGenie
            </h1>
          </div>
        </div>
      </div>

      <div className="max-w-[1200px] w-full p-8 rounded-[3rem] bg-white shadow-xl shadow-purple-100 relative overflow-hidden border border-purple-50">
        {/* Background Accents */}
        <div className="absolute -top-24 -right-24 w-64 h-64 bg-purple-50 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-purple-50 rounded-full blur-3xl"></div>

        {!selectedLaunchpad ? (
          <>
            <div className="mb-10 text-center relative z-10">
              <h2 className="text-4xl font-black text-[#5B21B6] uppercase tracking-tighter mb-2">
                Launchpad MCQs
              </h2>
              <p className="text-gray-400 font-black uppercase text-[10px] tracking-[0.2em]">
                Master Industry Tracks with Guided Practice
              </p>
            </div>
            <LaunchpadGrid onLaunchpadClick={handleLaunchpadClick} />
          </>
        ) : (
          <LaunchpadDetails
            selectedLaunchpad={selectedLaunchpad}
            onBack={handleBack}
          />
        )}
      </div>
    </div>
  );
};

export default LaunchpadPage;



